import { render, staticRenderFns } from "./ConfermaUtente.vue?vue&type=template&id=29fbb842"
import script from "./ConfermaUtente.vue?vue&type=script&lang=js"
export * from "./ConfermaUtente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports